import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import styled from 'styled-components'
import TableHead from '../../atoms/share/TableHead'
import TableBody from '../../atoms/share/TableBody'
import { years, months } from '../../../modules/date'
import { fetchEmployeeInfo } from '../../../api/employee'
import { fetchTimestamps, deleteTimestamp } from '../../../api/timestamp'
import { EmployeeInfo } from '../../../types/employee'
import ButtonRed from '../../atoms/share/button/ButtonRed';
import ButtonSecondary from '../../atoms/share/button/ButtonSecondary';

export interface Props {
  id: number;
}

export const ScheduleTable: React.FC<Props> = ({ id }) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [employee, setEmployee] = useState<EmployeeInfo>({
    id: id, name: '', cell: '', birthday: '', email: '', department_id: null, department_name: '', employment_status_id: null, employment_status_name: ''
  })
  const [timestamps, setTimestamps] = useState([]);

  useEffect(() => {
    fetchEmployeeInfo(id)
      .then((res) => { setEmployee(res.data) })
    fetchTimestamps(id)
      .then((res) => { setTimestamps(res.data) })
      .catch(() => { window.alert('データの取得に失敗しました')})
  }, []);

  const heads = ['日付', '出勤時刻', '退勤時刻', '備考・メモ', '']

  const handleSubmit = () => {
    fetchTimestamps(id, selectedYear.value, selectedMonth.value)
      .then((res) => {
        setTimestamps(res.data)
      })
      .catch(() => {
        window.alert('データの取得に失敗しました')
      })
  }

  const handleDelete = (id: number) => {
    if (id === null) {
      return;
    }
    const confirmed = window.confirm('記録を削除します。よろしいですか？');

    if (confirmed) {
      deleteTimestamp(id)
        .then((res) => {
          fetchTimestamps(res.data.employee_id)
            .then((res) => { setTimestamps(res.data) })
        })
        .catch(() => {
          window.alert('通信に失敗しました')
        });
    }
  }

  return (
    <ScheduleTableArea>
      <Top>
        <Section>
          <Name>{employee.name}</Name>
          <SelectBox><Select value={selectedYear} onChange={setSelectedYear} options={years} />年</SelectBox>
          <SelectBox><Select value={selectedMonth} onChange={setSelectedMonth} options={months} />月</SelectBox>
          <ButtonBox>
            <ButtonSecondary text='表示する' onClick={handleSubmit} disabled={ !selectedYear || !selectedMonth } />
          </ButtonBox>
        </Section>
      </Top>
      <Table>
        <TableHead items={heads} />
        <Tbody>
          {timestamps.map((timestamp, index) => (
            <Row key={index} color={timestamp.is_holiday || timestamp.is_paid_leave ? "rgba(248, 190, 188, 0.5)" : "#ffffff"}>
              <TableBody>{timestamp.date}</TableBody>
              <TableBody>{timestamp.punch_in_at}</TableBody>
              <TableBody>{timestamp.punch_out_at}</TableBody>
              <TableBody>{timestamp.note}</TableBody>
              <TableBody>
                {timestamp.id !== null && (
                  <TableButtonArea>
                    <ButtonRed text='削除' onClick={() => handleDelete(timestamp.id)} />
                  </TableButtonArea>
                )}
              </TableBody>
            </Row>
          ))}
        </Tbody>
      </Table>
    </ScheduleTableArea>
  )
}

const ScheduleTableArea = styled.div`
  margin: 0 0 100px 0;
`
const Top = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto 24px;
`
const Section = styled.div`
  align-items: center;
  display: flex;
`
const Name = styled.div`
  margin-right: 40px;
  font-size: 16px;
`
const SelectBox = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  font-size: 16px;
`
const ButtonBox = styled.div`
  margin: 0 0 0 50px;
`
const Table = styled.table`
  border-collapse: collapse;
  margin: 0 auto;
  width: 80%;
  table-layout: auto;
`
const Tbody = styled.tbody`
  display: contents;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 500px;
`
const Row = styled.tr`
  border-bottom: 1px solid #6b7280;
  background-color: ${(props) => props.color};
`
const TableButtonArea = styled.span`
  display: block;
  text-align: center;
`

export default ScheduleTable
